import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import { BsPlus, BsDash } from 'react-icons/bs';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FAQ = () => {
  const { ref: titleRef, inView: titleInView } = useScrollAnimation();
  const { ref: accordionRef, inView: accordionInView } = useScrollAnimation({ threshold: 0.2 });

  const faqs = [
    {
      question: 'Which Madhabs are supported?',
      answer: 'We aim to support all Madhabs as we continue to build and expand the platform. Our goal is to be inclusive and respectful of the diversity within Islamic scholarship.'
    },
    {
      question: 'Can I use the app if I have an irregular cycle?',
      answer: 'Absolutely. We recognize that every body is different, and we’re here to support you through any irregularities with care, understanding, and sensitivity.'
    },
    {
      question: 'Can I delete my data permanently?',
      answer: 'Yes.Our work is grounded in the Islamic values of Amanah (trust) and Ihsan (excellence). Your privacy is important to us, and we are committed to handling your data responsibly. You can permanently delete your profile and data at any time.'
    },
    {
      question: 'Is this app suitable for converts?',
      answer: 'Yes. Whether you are new to Islam or further along in your journey, we’re here to support you at every stage of your faith-based life with compassion and guidance.'
    }
  ];

  return (
    <section id="faq" className="faq-section">
      <Container>
        <h2 
          ref={titleRef}
          className={`faq-title text-center animate-on-scroll fade-in-up ${titleInView ? 'visible' : ''}`}
        >
          Frequently Asked Questions
        </h2>
        <Accordion 
          ref={accordionRef}
          className={`faq-accordion animate-on-scroll fade-in ${accordionInView ? 'visible' : ''}`}
          flush
        >
          {faqs.map((faq, index) => (
            <Accordion.Item eventKey={index.toString()} key={index} className="faq-item">
              <Accordion.Header className="faq-header">
                <span className="faq-question">{faq.question}</span>
                <span className="faq-icon">
                  <BsPlus className="icon-plus" size={28} />
                  <BsDash className="icon-minus" size={28} />
                </span>
              </Accordion.Header>
              <Accordion.Body className="faq-body">
                {faq.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
};

export default FAQ;